import { Injectable, OnInit } from '@angular/core';
import { Observable, BehaviorSubject } from 'rxjs';
import { Router } from '@angular/router';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { User } from '../_model/user.model';
import { tap } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class LoginService {
    
  model: any = {};
  apiUrl: string;

  private currentUserSubject: BehaviorSubject<User>;
  public currentUser: Observable<User>;

  constructor(private _http: HttpClient, private _Route: Router) {
    this.currentUserSubject = new BehaviorSubject<User>(JSON.parse(localStorage.getItem('currentUser')));
    this.currentUser = this.currentUserSubject.asObservable();
    this.apiUrl = 'https://mktgcost.iffco.coop/api/Login/';
  }

  public get currentUserValue(): User {
    return this.currentUserSubject.value;
  }

  LoginUser( loginmodel: any )
  {
    debugger;
    let headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    return this._http.post<any>(this.apiUrl + 'LoginMktgCost', loginmodel, { headers: headers })
      .pipe(tap(data => {
        
        if (data.length > 0) {
          if (data) {
            localStorage.setItem( 'currentUser', JSON.stringify( { userId: data[0]._UsrId, password: data[0]._Password, partyname: data[0]._PartyName, token: data[0].token, UnitName: data[0].UnitName, ErpUnitCode: data[0].ErpUnitCode, ErpParentUnit: data[0].ErpParentUnit }));
            this.currentUserSubject = new BehaviorSubject<User>(JSON.parse(localStorage.getItem('currentUser')));
            this.currentUser = this.currentUserSubject.asObservable();
          }
          return data;
        } else {
          return null;
        }
      })

      );
  }

  LogoutUser() {

    localStorage.removeItem('currentUser');
    localStorage.removeItem('IffcoUnitCodeS');
    localStorage.removeItem('UnitName');
    this.currentUserSubject.next(null);
    this._Route.navigate(['/']);
  }
}
